export default "__VITE_ASSET__a1236165__"